import React, { memo } from 'react';
import { Outlet } from 'react-router-dom';

import { useLoadOffer } from '../hooks';

function OfferLoader() {
    useLoadOffer();

    return <Outlet />;
}

export default memo(OfferLoader);
